// extracted by mini-css-extract-plugin
export default {"marketplaceRouter":"_k1dqvy","marketplaceRouterEditor":"_m3c0ob","marketplaceRouterSa":"_7ifxho"};